import ConsentInfoModal from '~/javascripts/components/DonateForm/ConsentInfoModal';
import PhoneNumberField from '~/javascripts/components/DonateForm/PhoneNumberField';
import store from '~/javascripts/store.js';
import { CountryDropdown } from 'react-country-region-selector';
import { observer } from 'mobx-react';

const DonorInfoCollectionFields = observer(() => {
  const revalidateBillingZipcode = (e) => {
    if (store.donateForm.billingZipcode !== '') {
      setTimeout(() => {
        $(e.target).siblings('#billingZipcode').parsley().validate();
      }, 0);
    }
  };

  const onlyEmailConsentVisible = () =>
    store.donateForm.country === 'uk' &&
    !store.donateForm.showAddressCollection;

  const emailConsentText = () => {
    if (onlyEmailConsentVisible()) {
      return (
        <div className='calm-email-consent-text'>
          <p>Email me with marketing updates about</p>
          <div className='flex space-x-1'>
            <p>charity: water&apos;s mission and initiatives</p>
            <a className='calm-question-mark' href='#more-consent-info'>
              ?
            </a>
          </div>
        </div>
      );
    } else {
      return 'Email';
    }
  };

  return (
    <div className='flex flex-wrap input-wrapper mb-0'>
      {store.donateForm.isIndividualAccount ? (
        <>
          <div className='flex space-x-3 my-2'>
            <div>
              <label className='calm-label' htmlFor='name'>
                First Name
              </label>
              <input
                className='input'
                data-parsley-error-message='First name is required'
                data-parsley-not-a-credit-card-number
                id='name'
                name='name'
                onChange={(e) => (store.donateForm.name = e.target.value)}
                required={true}
                type='text'
                value={store.donateForm.name}
              />
            </div>
            <div>
              <label className='calm-label' htmlFor='surname'>
                Last Name
              </label>
              <input
                className='input'
                data-parsley-error-message='Last name is required'
                data-parsley-not-a-credit-card-number
                id='surname'
                name='surname'
                onChange={(e) => (store.donateForm.surname = e.target.value)}
                required={true}
                type='text'
                value={store.donateForm.surname}
              />
            </div>
          </div>
        </>
      ) : (
        <div className='w-full my-2'>
          <label className='calm-label' htmlFor='name'>
            Name
          </label>
          <input
            className='input'
            data-parsley-error-message='Name is required'
            data-parsley-not-a-credit-card-number
            id='name'
            name='name'
            onChange={(e) => (store.donateForm.name = e.target.value)}
            required={true}
            type='text'
            value={store.donateForm.name}
          />
        </div>
      )}

      {store.donateForm.showAddressCollection && (
        <>
          <div className='input-wrapper w-full mt-1'>
            <label className='calm-label' htmlFor='billingAddress'>
              {store.donateForm.country == 'uk'
                ? 'Postal Address'
                : 'Mailing Address'}
            </label>
            <input
              className='input'
              data-parsley-error-message='Mailing address is required'
              data-parsley-not-a-credit-card-number
              id='billingAddress'
              name='billingAddress'
              onChange={(e) =>
                (store.donateForm.billingAddress = e.target.value)
              }
              required={true}
              type='text'
              value={store.donateForm.billingAddress}
            />
          </div>
          <div className='input-wrapper flex space-x-3 mt-1'>
            <div>
              <label className='calm-label' htmlFor='billingCity'>
                {store.donateForm.country == 'uk' ? 'Town or City' : 'City'}
              </label>
              <input
                className='input'
                data-parsley-error-message='City is required'
                data-parsley-not-a-credit-card-number
                id='billingCity'
                name='billingCity'
                onChange={(e) =>
                  (store.donateForm.billingCity = e.target.value)
                }
                required={true}
                type='text'
                value={store.donateForm.billingCity}
              />
            </div>
            <div>
              <label className='calm-label' htmlFor='billingZipcode'>
                {store.donateForm.country == 'uk' ? 'Postcode' : 'Zipcode'}
              </label>
              <input
                className='input'
                data-parsley-error-message='Zipcode is required'
                data-parsley-not-a-credit-card-number
                id='billingZipcode'
                name='billingZipcode'
                onChange={(e) =>
                  (store.donateForm.billingZipcode = e.target.value)
                }
                required={true}
                type='text'
                value={store.donateForm.billingZipcode}
              />
            </div>
          </div>
          <div className='input-wrapper mt-1'>
            <label className='calm-label' htmlFor='billingCountry'>
              Country
            </label>
            <CountryDropdown
              classes='rounded-b -mt-px mb-1'
              id='billingCountry'
              onChange={(value, e) => {
                store.donateForm.billingCountry = value;
                revalidateBillingZipcode(e);
              }}
              required
              showDefaultOption={false}
              value={store.donateForm.defaultOrSelectedBillingCountry}
              valueType='short'
            />
          </div>
        </>
      )}

      {!store.donateForm.isUserLoggedIn && (
        <div className='w-full'>
          <label className='calm-label' htmlFor='email'>
            Email
          </label>
          <div className='input-wrapper w-full'>
            <input
              className='rounded border-grey-40'
              data-parsley-email-tld=''
              data-parsley-error-message='Please enter a valid email address'
              id='email'
              onChange={(e) => (store.donateForm.email = e.target.value)}
              required
              type='email'
              value={store.donateForm.email}
            />
          </div>
        </div>
      )}

      {!onlyEmailConsentVisible() && (
        <div className='input-wrapper w-full mt-1'>
          <label className='calm-label' htmlFor='phoneNumber'>
            Phone Number
            {!store.donateForm.phoneNumberConsentGranted && ' (optional)'}
          </label>
          <PhoneNumberField
            customInputWrapperClassName='mb-0'
            hideOptionalPlaceholder={true}
            isRequired={store.donateForm.phoneNumberConsentGranted}
          />
        </div>
      )}

      {!onlyEmailConsentVisible() && (
        <div className='w-full text-left my-1 space-x-2 flex calm-opt-in-text'>
          <p>Choose how you want to hear from us</p>
          <a className='calm-question-mark' href='#more-consent-info'>
            ?
          </a>
        </div>
      )}

      <div className='flex space-x-6 w-full my-1'>
        {store.donateForm.showAddressCollection && (
          <div className='calm custom-check'>
            <input
              defaultChecked={store.donateForm.mailConsentGranted}
              id='mail-consent-granted'
              name='mail_consent_granted'
              onChange={() =>
                (store.donateForm.mailConsentGranted =
                  !store.donateForm.mailConsentGranted)
              }
              type='checkbox'
              value={store.donateForm.mailConsentGranted}
            />
            <label htmlFor='mail-consent-granted'>
              {store.donateForm.country == 'uk' ? 'Post' : 'Mail'}
            </label>
          </div>
        )}
        {!store.donateForm.isUserLoggedIn && (
          <div className='calm custom-check'>
            <input
              defaultChecked={store.donateForm.emailConsentGranted}
              id='email-consent-granted'
              name='email_consent_granted'
              onChange={() =>
                (store.donateForm.emailConsentGranted =
                  !store.donateForm.emailConsentGranted)
              }
              type='checkbox'
              value={store.donateForm.emailConsentGranted}
            />

            <label htmlFor='email-consent-granted'>{emailConsentText()}</label>
          </div>
        )}
        {store.donateForm.country !== 'uk' && (
          <div className='calm custom-check'>
            <input
              defaultChecked={store.donateForm.phoneNumberConsentGranted}
              id='text-consent-granted'
              name='text_consent_granted'
              onChange={() =>
                (store.donateForm.phoneNumberConsentGranted =
                  !store.donateForm.phoneNumberConsentGranted)
              }
              type='checkbox'
              value={store.donateForm.phoneNumberConsentGranted}
            />
            <label htmlFor='text-consent-granted'>Text message</label>
          </div>
        )}
      </div>
      {store.donateForm.country === 'uk' && (
        <p className='calm-disclaimer-text text-left pb-2'>
          By clicking &ldquo;Next&rdquo;, you are submitting your information to
          charity:&nbsp;water.
        </p>
      )}
      {store.donateForm.country !== 'uk' && (
        <p className='calm-disclaimer-text text-left pb-2'>
          By clicking &ldquo;Next&rdquo;, you are submitting your information to
          charity:&nbsp;water
          {store.donateForm.embedded
            ? ' and the retailer on whose website this form is located'
            : ''}
          . If you have opted to receive text messages, you agree to receive
          messages such as promotions, offers, alerts, and donation requests.
          Consent is not a condition of purchase. Reply HELP to 71537 for help
          and STOP to cancel. Msg frequency varies. Msg & data rates may apply.
          View{' '}
          <a
            className='font-normal underline'
            href='https://www.charitywater.org/sms-terms-of-service'
          >
            Terms
          </a>
          {' & '}
          <a
            className='font-normal underline'
            href='https://www.charitywater.org/privacy-policy/sms'
          >
            Privacy
          </a>
          .
        </p>
      )}

      <ConsentInfoModal
        includeMail={true}
        includeSms={store.donateForm.country !== 'uk'}
        modalId='more-consent-info'
      />
    </div>
  );
});

export default DonorInfoCollectionFields;
